import { FaceDetection, FaceDetail } from 'types/amazon'
import {
  PhraseLatencies,
  SessionLatencies,
  Device,
  SessionType,
  VideoAIAnalysis,
  VideoAIAnalysisDetails,
  MediaFile,
  DBT
} from 'types/internal'
import { IpDetailsT, MaxmindCityT } from 'types/ipDetails'
export namespace TwoFactorT {
  export enum StepTypeT {
    QUESTION = 'question',
    LANDING = 'landing',
    REPLY = 'reply'
  }

  export type BrandingT = {
    url: string
    fit: 'cover' | 'logo'
  }

  export type ButtonT = {
    label: string
    variant?: 'solid' | 'outline' | null
    color?: string | null
  }

  export type LandingT = {
    id: 'landing'
    branding?: BrandingT
    primaryHeading: string
    locationSubheading?: string
    ctaText: string
    termsAndConditionsUrl?: string
    actionButton: ButtonT
    actionButton2: ButtonT
    buttonPressed?: 0 | 1
    sType: StepTypeT.LANDING
  }

  export interface QuestionT {
    id: string
    createdAt: number
    length?: number
    thumbnail?: string
    mediaUrl?: string
    text: string
    answerText?: string
    answerId?: string
    sType: StepTypeT.QUESTION
    backendLatencies?: Record<string, number>
    aiLatency?: number
    heyGenLatency?: number
    isApplied?: boolean
    flags?: { key: string; value: string }[]
    stage?: string
    replyGenerationLatency?: number
    dgLatency?: number
    latencies?: PhraseLatencies
  }

  export interface ReplyT {
    id: string
    text: string
    createdAt: number
    mediaUrl?: string
    sType: StepTypeT.REPLY
    name?: string
    deepgramLatency?: number
  }

  export type StepT = QuestionT | LandingT | ReplyT

  export type RekognitionT = {
    startTime: number
    endTime: number
    faces: FaceDetection[]
  }

  export type VariantT = 'LlmSystem' | 'OpenAI' | 'Custom'
  export type AvatarT = 'heygen' | 'azure' | 'custom' | 'd-id'

  export type ImageRekognitionT = {
    startTime: number
    endTime: number
    faces: FaceDetail[]
  }

  export type AIAnalysisSection = {
    title: string
    shortDescription: string
    longDescription: string
  }

  export type AIAnalysis = {
    bestPhotoIndex: number
    ageMin: number
    ageMax: number
    sex: 'male' | 'female'
    realPersonOrVirtual: 'real' | 'virtual' | 'noface'
    overallSummary: string
    analysis: AIAnalysisSection[]
  }

  export type EmailAttemptT = {
    ts: string
    timestamp: number
    deliveredAt?: number
  }

  export type VerificationT = {
    id: string
    code: string
    email: string
    createdAt: number
    updatedAt?: number
    agreed: boolean
    slackNotifications?: Record<string, EmailAttemptT>
    isTest?: boolean
  }

  export type T = {
    id: string
    createdAt: number
    steps: StepT[]
    completed: boolean
    // rekognition?: Record<string, RekognitionT>
    deviceDetails?: Device
    ipDetails?: IpDetailsT
    userId?: string
    isNotNew?: boolean
    slackTs?: string
    slackNotificationsDisabled?: boolean
    // variant?: VariantT
    transcriptSlackTs?: string
    // logsSlackTs?: string
    avatar?: AvatarT
    verificationId: string | null
    isVerified?: boolean
    userName?: string
    // Private object refs (path + contentType within the interactions bucket).
    // userVideo = user camera; avatarVideo = avatar+user composite for playback.
    // Phase 5: both are now written from server-side Egress outputs (userVideo
    // track + RoomComposite) instead of client videoChunk uploads.
    userVideo?: MediaFile
    avatarVideo?: MediaFile
    // Legacy public-URL fields — no longer written, kept for reading old docs.
    userVideoUrl?: string
    avatarVideoUrl?: string
    userVideoMimeType?: string
    avatarVideoMimeType?: string
    // imageRekognition?: ImageRekognitionT[]
    // userAvatarUrl?: string
    // userScreenshots?: string[]
    // chunksCompleted?: boolean
    // webmDuration?: number
    isBot?: boolean
    version?: string
    // model?: string
    // isDev?: boolean
    firstName: null | string
    lastName: null | string
    // recapVideoUrl?: string
    // aiAnalysisFirst?: AIAnalysis
    // aiAnalysis?: AIAnalysis
    ip?: string
    location?: MaxmindCityT
    lang?: string
    transcriber?: string
    // recognitionDemo?: boolean
    emailInputSkipped?: boolean
    livenessDetected?: boolean
    avatarId?: string
    avatarQuality?: string
    libVersions?: Record<string, string>
    latencies?: SessionLatencies
    sessionType: SessionType.DEMO2 | SessionType.DEMO1
    email?: string
    videoAIAnalysis?: VideoAIAnalysis
    videoAIAnalysisDetails?: VideoAIAnalysisDetails
    videoAnalysisErrorCode?: string
    user?: DBT.VegasUserT
    screenshots?: Record<string, DBT.ScreenshotT>
  }

  export type RecapT = T
}
